/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_N1Inputs */

const en_to_xml_ref_n1 = /** @type {(inputs: To_Xml_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An object key becomes an element containing the value.`)
};

const ko_to_xml_ref_n1 = /** @type {(inputs: To_Xml_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`객체 키는 값을 담은 요소가 됩니다.`)
};

const ja_to_xml_ref_n1 = /** @type {(inputs: To_Xml_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オブジェクトのキーは値を含む要素になります。`)
};

/**
* | output |
* | --- |
* | "An object key becomes an element containing the value." |
*
* @param {To_Xml_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_n1 = /** @type {((inputs?: To_Xml_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_n1(inputs)
	if (locale === "ko") return ko_to_xml_ref_n1(inputs)
	return ja_to_xml_ref_n1(inputs)
});